import React, {
  Component,
  CSSProperties,
  MouseEvent as ReactMouseEvent,
  MouseEventHandler,
  Fragment,
} from 'react'
import cn from 'classnames'
import './CircularLoader.css';


export type CirleLoaderProps = {

  loadingColor?: string
  size?: string,
  style?: CSSProperties
}

class CircularLoader extends Component<CirleLoaderProps> {
  public static propTypes: any = {}

  render() {
    const {
      size = 'small',
      style = {}
    }: any = this.props;

    const classNames = cn('CircularLoader', {
      [`CircularLoader--size-${size}`]: size
    })

    return (
      <div style={style} className={classNames}></div>
    )
  }
}
export default CircularLoader
